// extracted by mini-css-extract-plugin
module.exports = {"hintText":"add-form-group_hintText__TkGjE"};